<template>
  <div class="primary-link cursor-pointer" @click="confirm()">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: [
    'actionUrl',
    'successUrl',
    'method',
    'message',
  ],
  methods: {
    confirm: function () {
      this.$confirm(
          {
            message: this.message,
            button: {
              no: 'Abbrechen',
              yes: 'Ja'
            },

            callback: confirm => {
              if (confirm) {
                this.perform();
              }
            }
          }
      )
    },
    perform: function () {
      this.$http[this.method](this.actionUrl).then(response => {
        window.location.href = this.successUrl
      }, response => {

      })
    }
  }
}
</script>